// testimonialsData.js
export const linkedinTestimonials = [
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7124913961052884992",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7118335718686351360",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7117916968757727232",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7117831896608239616",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7117187430352314370",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7112820631447969792",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7112807146525753345",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7107260715861766145",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7107072888003854336",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7107000916695773184",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7106928952912269312",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7105917014119981058",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7105893792565665792",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7105086249190785024",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7102183661294260225",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7102033768940482561",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7102010113921540098",
  },
  {
    url: "https://www.linkedin.com/embed/feed/update/urn:li:share:7118267879711465472",
  },
];

export const writtenTestimonials = [
  {
    name: "Russ Kirby",
    title: "CISO at Ping Identity",
    testimonial:
      "Mihir led the implementation of a new security model at ForgeRock, saving us over $500,000 and securing our critical cloud infrastructure.",
  },
  {
    name: "Kaila Pollart",
    title: "Director at Bugcrowd",
    testimonial:
      "Mihir's innovative approach to cloud security has been critical to improving Bugcrowd's security offerings.",
  },
  {
    name: "Abhimanyu Dhamjia",
    title: "CEO at Koala Labs",
    testimonial:
      "Mr. Shah is highly regarded for his accomplishments. He is certainly one of the highest-level of cybersecurity engineers I've met.",
  },
  {
    name: "Dr. D Paul Benjamin",
    title: "Professor of Computer Science at Pace University",
    testimonial:
      "It is my conclusion that Mr. Shah is indeed among a select few individuals to have risen to the peak of the field of cybersecurity.",
  },
  {
    name: "Dr. Weifeng Chen",
    title: "Professor of Computer Science at Pennsylvania Western University",
    testimonial:
      "Mihir Shah has put forth numerous innovations and tools that have been widely accepted by the global cybersecurity community and has also received national and international recognitions for these contributions.",
  },
  {
    name: "Mr. Vadan Kumar",
    title: "Cofounder at UBlood",
    testimonial:
      "Meeting the highest standard of security for our applications was a mission-critical top priority for our company. It is for this reason that I sought the expertise of Mr. Mihir Shah to perform a security assessment for the AWS, Android, iOS, and Web App for UBlood.",
  },
  {
    name: "Mr. Gagan Sarawgi",
    title: "Cofounder at NvisnX",
    testimonial:
      "Mr. Mihir Shah is an exceptional leader and one of the luminary experts who has made contributions of major importance to the field.",
  },
  {
    name: "Mr. Asheer Malhotra",
    title: "Security Research Leader at Cisco",
    testimonial:
      "Mr. Mihir Shah's book has been a crucial resource in the success of our business initiatives.",
  },
  {
    name: "Mr. Arun Perumal",
    title: "Site Reliability Engineer at Adobe",
    testimonial:
      'Mr. Shah\'s "Cloud Native Software Security Handbook" represents a significant breakthrough in our field.',
  },
  {
    name: "Mr. Mayank Jindal",
    title: "Software Engineer at Amazon",
    testimonial:
      "Mr. Shah's remarkable book has truly had a profound impact on my endeavors, blending theoretical concepts and practical applications commendably.",
  },
];
